import React from 'react';
import styles from './OtvetyBanner.module.css';

const OtvetyBanner = () => {
  return (
    <a className={styles.wrapper} href="https://uchi.ru/otvety" target="_blank">
      Остались вопросы?
      <br /> Спроси знающих ребят на&nbsp;Учи.Ответах!
    </a>
  );
};

export default OtvetyBanner;
